import { api } from "./configs/axiosConfigs"

export const TicketAPI = {

    getTicket: async (data: any) => {
        const response = await api.get(
            '/ticket', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getByNroTicket: async (nro_ticket: any) => {
        const response = await api.get(
            `/ticket/nr_ticket/${nro_ticket}`,
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getRoutes: async (data: any) => {
        const response = await api.get(
            '/ticket/route', { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getRoutesInvoice: async (id: number, data: any) => {
        const response = await api.get(
            `/ticket/route-invoice/${id}`, { params: { ...data } }
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getRoutePDF: async (idroute) => {
        const response = await api.get(
            `/ticket/route-pdf/${idroute}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getDispatchPDF: async (idroute, id) => {
        const response = await api.get(
            `/ticket/dispatch-pdf/${idroute}/${id}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    createTicket: async (data: any) => {
        const response = await api.post(
            '/ticket/register', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    updateTicket: async (data: any) => {
        const response = await api.post(
            '/ticket/update', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    createRelationTicket: async (data: any) => {
        const response = await api.post(
            '/ticket/registerRelation', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    createRoute: async (data: any) => {
        const response = await api.post(
            '/ticket/route', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    editTicket: async (idstore: number, data: any) => {
        const response = await api.patch(
            `/ticket/${idstore}`, data
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    updateStatusRouteTicket: async (idticket: number, data: any) => {
        const response = await api.patch(
            `/ticket/changeStatusRoute/${idticket}`, data
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    updateRoute: async (idroute: number, data: any) => {
        const response = await api.patch(
            `/ticket/route/${idroute}`, data
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    deleteTicket: async (idticket: number) => {
        const response = await api.delete(
            `/ticket/${idticket}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    generateDocument: async (data: any) => {
        const response = await api.post(
            '/ticket/document', data
        ).then(response => response.data)
            .catch((error) => {
                console.error(error)
                return error.response.data
            })
        return response
    },

    confirmTicket: async (id: number, payload?: object) => {
        const response = await api.patch(
            `/ticket/confirm/${id}`, payload
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    changeStatus: async (id: number, payload?: object) => {
        const response = await api.patch(
            `/ticket/changeStatus/${id}`, payload
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    partialCancelation: async (id: number, payload?: object) => {
        const response = await api.patch(
            `/ticket/partialCancelation/${id}`, payload
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

    getTrackerTicket: async (id: number | string) => {
        const response = await api.get(
            `/ticket/tracker/${id}`
        ).then(response => response.data)
            .catch((error) => {
                return error.response.data
            })
        return response
    },

}